/**
 * A module to handle cookies (excluding HttpOnly cookies, which must be set on the server).
 */
const cookieHandler = {
  /**
   * Sets a cookie.
   * @param {string} name - The name of the cookie.
   * @param {string} value - The value of the cookie.
   * @param {number} [days] - Optional: Number of days until the cookie expires. If not provided, it will be a session cookie.
   */
  setCookie: function (name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },

  /**
   * Retrieves a cookie value by name.
   * @param {string} name - The name of the cookie.
   * @returns {string|null} - Returns the cookie value or null if not found.
   */
  getCookie: function (name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  /**
   * Deletes a cookie by name.
   * @param {string} name - The name of the cookie.
   */
  eraseCookie: function (name) {
    document.cookie = name + "=; Max-Age=-99999999; path=/";
  }
};

// Usage Example
// cookieHandler.setCookie('username', 'JohnDoe', 7);
// const username = cookieHandler.getCookie('username');
// cookieHandler.eraseCookie('username');

export default cookieHandler;
